/** VND helpers */
export const formatVND = (n = 0) => {
  if (typeof n !== "number") n = Number(n) || 0;
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
};

export const formatVNDDelta = (n = 0) => {
  const sign = n > 0 ? "+" : "";
  return sign + formatVND(n);
};
